import ApiService from '@/services/ApiService'
import store from '@/store/store'
import swal from 'sweetalert'
import TranslationService from '@/services/TranslationService'

let api = new ApiService()

export default {
    async getReservations (customerID) {
        let result = await api.get(`/customers/${customerID}/reservations`)
        return result
    },

    async updateCustomerDetails (user) {
        if (user.CompanyName.length < 2) {
            swal('', TranslationService.get('MissingCompanyName'), 'warning')
        } else {
            let result = await api.patch(`public/registerUser/${user.ContactID}`, user)
            if (result && result.UserName) {
                // Commit details to Store and show a success message
                store.dispatch('setUser', result)
                swal('', TranslationService.get('SUCESSFULLY_EDITED_USER_DETAILS'), 'success')
            } else {
                swal('', TranslationService.get('SOMETHING_WENT_WRONG'), 'warning')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/CustomerService.js